import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { PasswordChange } from '../../../../../common/model/auth/password-change.model';
import { AlertModule } from '../../../../../common/modules/bootstrap/alert/alert.module';
import { AbstractFormBuilderComponent } from '../../../../../common/modules/form/abstract-form-builder.component';
import { InputPasswordComponent } from '../../../../../common/modules/form/input-password/input-password.component';
import { FormErrors } from '../../../../../common/modules/form/model/form-errors.model';
import { AuthService } from '../../../../../common/services/auth.service';
import { SpreadRecursive } from '../../../../../common/services/spread-recursive';

@Component({
    templateUrl: './change-password.template.html',
    imports: [
        RouterLink, ReactiveFormsModule,
        AlertModule, InputPasswordComponent,
    ],
})
export class ChangePasswordComponent extends AbstractFormBuilderComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private service = inject(AuthService);

    errors: FormErrors;
    loading = signal<boolean>(false);
    success = false;
    token: string|null = null;
    tokenExpiredError = false;

    ngOnInit(): void {
        super.ngOnInit();
        this.resetErrors();
        this.token = this.route.snapshot.queryParams.token;
    }

    onSubmit(): void {
        this.loading.set(true);
        const passwordChange: PasswordChange = {
            password: this.form.value.password,
            confirmation: this.form.value.confirmation,
            token: this.token,
        };
        this.service.changePassword(passwordChange)
            .pipe(finalize(() => this.loading.set(false)))
            .pipe(catchError((response: HttpErrorResponse) => {
                this.resetErrors();
                if (response.error?.errors) {
                    this.errors = SpreadRecursive.merge(this.errors, response.error.errors);
                } else {
                    this.tokenExpiredError = true;
                }

                return EMPTY;
            }))
            .subscribe(() => this.success = true);
    }

    protected createForm(): object {
        return {
            password: null,
            confirmation: null,
        };
    }

    private resetErrors(): void {
        this.tokenExpiredError = false;
        this.errors = {
            plainPassword: {
                password: [],
                confirmation: [],
            },
        };
    }
}
